module.exports = __webpack_public_path__ + "static/media/information.c4c28003.svg";